import loadable from '@loadable/component';

export const CmsScrollTrackingBlockLoadable = loadable(
  () => import('./CmsScrollTrackingBlock'),
  { resolveComponent: (module) => module.CmsScrollTrackingBlock },
);
